module.exports = __webpack_public_path__ + "img/chargingpoint-suggestion.2064782c.png";